import React from 'react';
import { Pagination } from '@components';
import { formatUseYn } from '@utils/formatUseYn';

const CodeHListSection = ({
    data,
    pageIndex,
    recordCountPerPage,
    handlePageChange,
    changePageSize,
    handleCodeH,
    filteredCodeD,
    setHDetailItem,
    setHDetailOpen
}) => {
    return (
        <section className="wp75">
            <div className="section-tit-wrap">
                <h3 className="border-left-primary !text-[19px] md:!text-[21px]">
                    &nbsp;공통코드(H) 조회
                    <span className="total-txt !text-[15px] md:!text-[16px]"> 
                        | 총 <span className='red'>{data?.codeHList?.length || 0}</span> 건
                    </span>
                </h3>
            </div>

            {/* Mobile: 축약 테이블 + 상세(모달) */}
            <div className="md:hidden table-container overflow-x-auto table-list-wrapper [-webkit-overflow-scrolling:touch]">
                <table className="table-list min-w-max !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '45%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>그룹코드</th>
                            <th>그룹명</th>
                            <th>사용</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.codeHList && data.codeHList.length > 0 ? (
                            Array.from(new Map(data.codeHList.map(item => [item.comhCode, item])).values()).map((item) => (
                                <tr
                                    key={item.comhCode}
                                    onClick={() => {
                                        handleCodeH(item.comhCode);
                                        filteredCodeD(item.comhCode);
                                        setHDetailItem(item);
                                        setHDetailOpen(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <td className="font-mono">{item.comhCode}</td>
                                    <td>{item.comhName}</td>
                                    <td>{formatUseYn(item.huseYn)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={3} className="table-empty" style={{ textAlign: 'center' }}>
                                    조회 결과가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Desktop: 전체 테이블 */}
            <div className="hidden md:block table-container overflow-x-auto table-list-wrapper [-webkit-overflow-scrolling:touch]">
                <table className="table-list min-w-max !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>그룹코드</th>
                            <th>그룹명</th>
                            <th>정렬순서</th>
                            <th>사용여부</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.codeHList && data.codeHList.length > 0 ? (
                            Array.from(new Map(data.codeHList.map(item => [item.comhCode, item])).values()).map((item) => (
                                <tr
                                    key={item.comhCode}
                                    onClick={() => { 
                                        handleCodeH(item.comhCode); 
                                        filteredCodeD(item.comhCode); 
                                    }}
                                    style={{ cursor: "pointer" }}>
                                    <td>{item.comhCode}</td>
                                    <td>{item.comhName}</td>
                                    <td>{item.hsort}</td>
                                    <td>{formatUseYn(item.huseYn)}</td>
                                    <td style={{ textAlign: "left" }}>{item.hnotice}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} className="table-empty" style={{ textAlign: 'center' }}>
                                    조회 결과가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '8px' }}>
                <span style={{ fontSize: '14px', whiteSpace: 'nowrap', color: '#555' }}>페이지당 행 수</span>
                <select
                    className="form-select form-select-sm"
                    style={{ width: 'auto' }}
                    value={recordCountPerPage}
                    onChange={(e) => changePageSize(Number(e.target.value))}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>

            {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                        data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={10}
                />
            )}
        </section>
    );
};

export default CodeHListSection;
